import { computed, ref, type ComputedRef, type WritableComputedRef } from 'vue'

import { type UpsellSourceValue } from './upsellTracking'

// The sheet can only be opened through openUpsellSheet, which always carries a
// source, so `activeSource` is non-null for the entire time the sheet is open.
// `null` means the sheet is closed.
const activeSource = ref<UpsellSourceValue | null>(null)

/**
 * Which gated control opened the sheet, read by the `UpsellSheet` host to
 * attribute its open/dismiss/upgrade analytics events. `null` only while the
 * sheet is closed (no events fire then).
 */
export const upsellSheetSource: ComputedRef<UpsellSourceValue | null> =
  computed(() => activeSource.value)

/**
 * Two-way open flag for the host `UpsellSheet` v-model. Assigning `true` is a
 * no-op: opening must go through `openUpsellSheet` so every open is attributed
 * to a source. Assigning `false` (dismiss) clears the source.
 */
export const isUpsellSheetOpen: WritableComputedRef<boolean> = computed({
  get: (): boolean => activeSource.value !== null,
  set: (open: boolean): void => {
    if (!open) {
      activeSource.value = null
    }
  },
})

/**
 * Opens the plan-upsell sheet, attributing it to the triggering control.
 * @param source
 */
export const openUpsellSheet = (source: UpsellSourceValue): void => {
  activeSource.value = source
}
